import { useMediaQuery } from './useMediaQuery';

/**
 * Hook para detectar si el dispositivo es móvil o tiene resolución de móvil
 * @param breakpoint - Ancho máximo en píxeles para considerar móvil (default: 768px)
 * @returns true si es móvil, false si es desktop
 */
export const useIsMobile = (breakpoint: number = 768): boolean => {
	return useMediaQuery(`(max-width: ${breakpoint}px)`);
};

